import { useEffect, useState } from 'react';

/**
 * Le téléphone a-t-il du réseau ? Ce que le navigateur en sait (`navigator.onLine`), suivi par
 * ses événements. Il peut se croire en ligne sans l'être : une création qui échoue alors part
 * quand même dans la file hors ligne (`useAjouterParLePlus`).
 */
export function useEnLigne(): boolean {
  const [enLigne, setEnLigne] = useState(() => typeof navigator === 'undefined' || navigator.onLine !== false);
  useEffect(() => {
    const suivre = () => setEnLigne(navigator.onLine !== false);
    window.addEventListener('online', suivre);
    window.addEventListener('offline', suivre);
    return () => {
      window.removeEventListener('online', suivre);
      window.removeEventListener('offline', suivre);
    };
  }, []);
  return enLigne;
}
